import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginConfigService } from '@services/login-config/login-config.service';
import { LogoutService } from '@services/logout/logout.service';
import { AddinView, AuthenticationService, LoginConfiguration, LoginSetupState, LoginStateService, SetupError } from '@techwan/ionic-core';
import { LoginTypes } from '@techwan/security';
import { LoginHandlerService } from '../../services/login-handler/login-handler.service';
import { LoginSetupComponent } from '../login-setup/login-setup.component';

export enum View {
  login,
  loading
}

@Component({
  selector: 'app-generic-login',
  templateUrl: 'generic-login.component.html',
  styleUrls: ['generic-login.component.scss']
})
@AddinView({
  name: 'GenericLogin'
})
export class GenericLoginComponent extends LoginSetupComponent implements OnInit, OnDestroy {
  view: View = View.login;

  readonly loginView = View.login;
  readonly loadingView = View.loading;

  get error(): string {
    return `SetupError.${SetupError[this.loginState.error]}`;
  }

  get hasError(): boolean {
    return this.loginState.error !== SetupError.none;
  }

  get config(): LoginConfiguration {
    return this.authentication.configuration;
  }

  get loginType(): LoginTypes {
    return LoginTypes[this.loginConfig.loginConfig.LoginType];
  }

  constructor(
    protected authentication: AuthenticationService,
    private loginHandler: LoginHandlerService,
    private loginConfig: LoginConfigService,
    private logoutService: LogoutService,
    private loginState: LoginStateService
  ) {
    super(authentication);
  }

  ngOnInit() {
    this.loginHandler.start();
    this._subs.push(this.loginState.state.subscribe(state => this.onLoginStateChanged(state)));
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.loginHandler.stop();
  }

  protected onShowLogin() {
    super.onShowLogin();
    this.view = View.login;
  }

  protected onLoginStateChanged(state: LoginSetupState) {
    switch (state) {
      case LoginSetupState.erroneous:
        this.view = View.login;
        break;

      default:
        this.view = View.loading;
    }
  }

  logout() {
    this.logoutService.logout();
  }
}
